import { render, staticRenderFns } from "./WheelBattleConsumerMatchTab.vue?vue&type=template&id=25bf9890&scoped=true&"
import script from "./WheelBattleConsumerMatchTab.vue?vue&type=script&lang=js&"
export * from "./WheelBattleConsumerMatchTab.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleConsumerMatchTab.vue?vue&type=style&index=0&id=25bf9890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf9890",
  null
  
)

export default component.exports